import { IconComponent } from './types';

const HeadlandsIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4.5" y="4.5" width="3" height="3" stroke="currentColor" />
    <rect x="0.5" y="0.5" width="11" height="11" stroke="currentColor" />
  </svg>
);

export default HeadlandsIcon;
